import { jsx, jsxs } from 'react/jsx-runtime';
import { Children, useMemo } from 'react';
import { TooltipWrapper } from '../TooltipWrapper/TooltipWrapper.es.js';

const avatarGroup = "_avatar-group_1lt12_1";
const count = "_count_1lt12_21";
const styles = {
	avatarGroup: avatarGroup,
	count: count
};

const AvatarGroup = ({ children, size = void 0, max = 3, overflowCopy }) => {
  const childrenArray = Children.toArray(children).filter(Boolean);
  const slicedChildren = childrenArray.slice(0, max);
  const remainingChildren = childrenArray.length - slicedChildren.length;
  const overflowTooltip = useMemo(() => overflowCopy || `Plus ${remainingChildren} others`, [overflowCopy, remainingChildren]);
  const content = size !== "large" ? jsx("div", { className: styles.count, "data-zds": true, children: overflowCopy || `${Math.min(remainingChildren, 999)} others` }) : jsx(TooltipWrapper, { content: overflowTooltip, position: "southeast", children: () => jsx("div", { "aria-label": overflowTooltip, className: styles.count, "data-zds": true, children: Math.min(remainingChildren, 999) }) });
  return jsxs("div", { className: styles.avatarGroup, "data-size": size, "data-zds": true, children: [slicedChildren, remainingChildren > 0 && content] });
};

export { AvatarGroup };
//# sourceMappingURL=AvatarGroup.es.js.map
